import '../scss/frontend.scss';
import eventsHandler from './parts/events-handler';
import Popup from './parts/popup-window';
import tabsNavigation from './parts/navi-tabs';
import Sliders from './components/swiper-init';
import initializeAccordion from './components/accordion';
import { checkCookies } from './components/cookie';
import { handleAllInputsFocus } from './parts/helpers';
import initTrialForm from './components/trial-form';
import { scrollToSection } from './components/scroll-to-section';
require('fslightbox');
function ready() {
    const popupInstance = new Popup();
    const header = document.querySelector('.site-header');
    popupInstance.init();
    window.document.addEventListener('scroll', () => {
        const operationType = header && Math.floor(window.scrollY) > 0 ? 'add' : 'remove';
        header.classList[operationType]('sticky');
    });
    {
        const operationType = header && Math.floor(window.scrollY) > 0 ? 'add' : 'remove';
        header.classList[operationType]('sticky');
    }
    eventsHandler();
    tabsNavigation('.js-tab-name', '.js-tab');
    initializeAccordion();
    Sliders.initMenuCulumnsSLider();
    Sliders.initSideContentSlider();
    checkCookies();
    initTrialForm();
    handleAllInputsFocus();
    scrollToSection();
}
window.document.addEventListener('DOMContentLoaded', ready);
